<template>
    <v-col cols="12">
        <v-row
            no-gutters
            justify="center"
        >
            <v-col cols="5">
                <v-row no-gutters class="flex-nowrap py-5">
                    <v-col class="shrink">
                        <v-row no-gutters style="border-radius: 50%; height:123px; width:123px" class="white" align="center" justify="center">
                            <v-col class="shrink"><v-img :max-height="74" contain :src="require('@/assets/uku-logo-colored.svg')" /></v-col>
                        </v-row>
                    </v-col>
                    <v-col class="mt-4">
                        <v-row no-gutters class="mb-2 white py-4 px-6" style="border-radius: 24px; border: 1px dashed black !important; margin-left:-10px">
                            <v-col class="title" style="line-height: 28px">
                                {{ $t('Import speeds up your clients setup, smart choice!') }}
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col
                        v-for="(option, key) in importOptions"
                        cols="12"
                        class="mb-3"
                        :key="key"
                    >
                        <v-btn
                            class="white flex px-3"
                            style="width: 100%; min-height: 60px"
                            x-large
                            @click="option.action()"
                        >
                            <v-img
                                v-if="option.image"
                                :src="option.image"
                                class="shrink"
                                height="40"
                                width="40"
                                contain
                            />
                            <div class="title text-left text-none pl-2" style="width: 100%">
                                {{ option.name }}
                            </div>
                            <v-tooltip v-if="option.description" bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon color="g4" v-on="on">mdi-help-circle-outline</v-icon>
                                </template>
                                {{ option.description }}
                            </v-tooltip>
                        </v-btn>
                        <div
                            v-if="option.type === 'excel' && lastExcelImportData"
                            class="caption g5--text font-weight-medium px-4 pt-2"
                        >
                            <div>
                                <template v-if="lastExcelImportData.failed_count === 1">
                                    {{ $t('Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client').format(lastExcelImportData.imported_count, lastExcelImportData.updated_count, lastExcelImportData.skipped_count, lastExcelImportData.failed_count) }}
                                </template>
                                <template v-else-if="lastExcelImportData.failed_count">
                                    {{ $t('Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients').format(lastExcelImportData.imported_count, lastExcelImportData.updated_count, lastExcelImportData.skipped_count, lastExcelImportData.failed_count) }}
                                </template>
                                <template v-else>
                                    {{ $t('Last import: added {0}, updated {1}, skipped {2}').format(lastExcelImportData.imported_count, lastExcelImportData.updated_count, lastExcelImportData.skipped_count) }}
                                </template>

                                <br/>
                                {{ lastExcelImportData.imported_at }}
                            </div>
                            <template v-if="lastExcelImportData.failed_count > 0">
                                <div class="my-2">{{ $t("What's next? Correct the data of {0} clients and upload again.").format(lastExcelImportData.failed_count) }}</div>
                                <span>
                                    {{ $t("Download") }}
                                    <a :href="`/api/import/${lastExcelImportData.import_session_id}/skipped`">
                                        {{ $t('failed_to_import.xlsx') }}
                                    </a>
                                </span>
                            </template>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import {ref, computed, onMounted} from '@vue/composition-api'
import { $t } from '@/i18n'
import { Router } from "@/composables/Router";
import { APP_STORE_APP_TYPES } from "@/helpers/constants";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import AccountModule from "@/store/modules/account";
import { getRegionAppTitle } from "../../helpers/helpers";
import {FEATURE_CLIENT_IMPORT, validateFeatureAllowed} from "@/modules/subscription/allowed_features";
import ApiImport from "@/api/integration/import"
import errorDialog from "@/views/ErrorDialog/errorDialog";
import {getManifestData} from '../AppStore/app-store-manifest'
import FeatureModule from '../../store/modules/feature'

export default {
    name: "ImportSelectionView",
    components: {},
    props: {},
    setup(props, context) {
        const router = Router();
        const account_id = ref(router.currentRoute.params.account_id ? parseInt(router.currentRoute.params.account_id) : 0);
        const lastExcelImportData = ref(null)
        const { appStoreDialogActions } = appStoreDialog()
        const { getAccountInfo, getAccount } = AccountModule();
        const {fetchAllApps} = FeatureModule();

        const selectedAccount = computed(() => getAccount(account_id.value).value)


        const getDefaultTab = (feature) => {
            switch (feature) {
                case  APP_STORE_APP_TYPES.MERIT_AKTIVA: return 'import';
                case APP_STORE_APP_TYPES.ECONOMIC: return 'import';
                case APP_STORE_APP_TYPES.SMART_ACCOUNTS: return 'import_clients';
                default: return 'settings';

            }
        }

        const openFeatureModal = (feature) => {
            const defaultTab = getDefaultTab(feature)

            appStoreDialogActions.openAppStoreModal(
                feature,
                account_id.value,
                {
                    dialogOptions: { defaultTab: defaultTab },
                    onUpdate: () => {
                    }
                }
            )
        }

        fetchAllApps({company_id: account_id.value}).then(resp => {
                resp.sort((a, b) => {
                    if(a.name === APP_STORE_APP_TYPES.QUICKBOOKS) return -1
                    if(a.name === APP_STORE_APP_TYPES.XERO) return -1
                    return a.id
                }).forEach(app => {
                    if (app.is_waiting_list) return
                    if (app.type !== 'integration') return
                    if (app.name === APP_STORE_APP_TYPES.COMPANIES_HOUSE) return
                    // todo :: declare list of accounting integrations and these only

                    let logoUrl = getManifestData(app.name, 'logo_url', selectedAccount.value)
                    importOptions.value.push({
                        type: app.name,
                        name: getRegionAppTitle(app.name, selectedAccount.value.region_code),
                        image: require(`../../assets/${logoUrl}`),
                        action: () => {
                            validateFeatureAllowed(FEATURE_CLIENT_IMPORT, selectedAccount.value)
                            openFeatureModal(app.name)
                        },
                        description: getManifestData(app.name, 'description', selectedAccount.value)
                    })
            })
        })

        const importOptions = ref([
            {
                type: 'excel',
                name: $t('Excel (XLS, XLSX) '),
                image: require('../../assets/microsoft-excel.svg'),
                action: () => {
                    validateFeatureAllowed(FEATURE_CLIENT_IMPORT, selectedAccount.value)
                    router.push({ name: "import_new", params: { account_id: account_id.value }});
                },
                description: $t('Instead of entering clients one by one, you can use file import for a large customer base.')
            }
        ])

        onMounted(async () => {
            try {
                const data = await ApiImport.getLastExcelImportData(account_id.value)
                if (data.import_session_id) {
                    if (data.import_in_progress) {
                        router.push({ name: 'import_status', params: { id: data.import_session_id }})
                    } else {
                        lastExcelImportData.value = data
                    }
                }

            } catch (e) {
                errorDialog.showError(e)
            }
        })

        return {
            importOptions,
            lastExcelImportData
        }
    }
};
</script>

<style scoped lang="scss">
.import-icon {
    height: 40px;
    max-width: 40px;
}
</style>
